'use client';

import DefaultIcon from '@/assets/images/Andritz.png';
import { type ProductBrief, type ProductSimple } from '@/domain/products/types';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { Suspense, useState } from 'react';

import AddToCartButton from './AddToCartButton';
import { CardSkeleton } from './CardSkeleton';
import styles from './ProductCard.module.scss';

const ProductDetailDialogWrapper = dynamic(() => import('../../ProductDetailDialog/ProductDetailDialogWrapper'));

type CardProps = {
  product: ProductSimple | ProductBrief;
  layout: 'small' | 'large';
  isInCart?: boolean;
};

const ProductCard = ({ product, layout, isInCart = false }: CardProps) => {
  const [visible, setVisible] = useState(false);

  const onClick = () => {
    setVisible(true);
  };

  return (
    <>
      {layout === 'small' ? (
        <div
          tabIndex={product.idProduct}
          role="button"
          data-testid="product-card"
          className={`${styles.smallProductCard} ${styles.blue}`}
          onClick={onClick}
        >
          <div className={styles.cardHeader}>
            <Image
              src={product.image?.replace('Image', 'image')?.replace('Icons', 'icons') || DefaultIcon}
              alt={product.product}
              width={70}
              height={70}
            />
          </div>
          <div className={styles.cardBody}>
            <span>
              <b>{product.product}</b>
            </span>
          </div>
        </div>
      ) : (
        <div
          tabIndex={product.idProduct}
          role="button"
          data-testid="product-card"
          className={styles.largeProductCard}
          onKeyDown={() => onclick}
          onClick={onClick}
        >
          <div className={styles.cardHeader}>
            <Image
              src={product.image?.replace('Image', 'image')?.replace('Icons', 'icons') || DefaultIcon}
              alt={product.product}
              width={70}
              height={70}
            />
          </div>
          <div className={styles.cardBody}>
            <h4>{product.product}</h4>
            <p>{product.description}</p>
          </div>
          <AddToCartButton product={product} isInCart={isInCart} />
        </div>
      )}
      {visible && (
        <Suspense fallback={<CardSkeleton />}>
          <ProductDetailDialogWrapper
            idProduct={product.idProduct}
            onClose={() => {
              setVisible(false);
            }}
          />
        </Suspense>
      )}
    </>
  );
};

export default ProductCard;
